import type { Turn } from '../../deep-dive-stage/types/deepDive.types';

export function collectAnswers(turns: Turn[]): string[] {
  return turns
    .filter(
      (turn): turn is Extract<Turn, { kind: 'question' }> =>
        turn.kind === 'question'
    )
    .sort((a, b) => a.questionIndex - b.questionIndex)
    .map((turn) => turn.answer);
}

export function collectLessons(turns: Turn[]): string[] {
  const lastTurn = turns[turns.length - 1];
  if (!lastTurn || lastTurn.kind !== 'lesson') return [];
  return lastTurn.lessons;
}
